import { Constant, Headers } from "../apiConstants";

const TokenValidationAPI = async () => {
  const endpoint = Constant.TOKEN_VALIDATION;
  const BaseUrl = Constant.BASE_URL;

  try {
    const response = await fetch(BaseUrl + "/" + endpoint, {
      method: "post",
      headers: Headers,
    });
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default TokenValidationAPI;
